var map = {
	"./FSIN.svg": "9330",
	"./SP.svg": "c551",
	"./USZ.svg": "afa1",
	"./ZA.svg": "3fc2",
	"./ZSD.svg": "97b8",
	"./cal.svg": "e77c",
	"./call.svg": "42eb",
	"./chat.svg": "f17e",
	"./demo.svg": "3b2a",
	"./el.svg": "2ac1",
	"./exch.svg": "3235",
	"./i1.svg": "033d",
	"./i11.svg": "8381",
	"./i12.svg": "a2d3",
	"./i2.svg": "4cb6",
	"./i3.svg": "351e",
	"./i4.svg": "11a0",
	"./i5.svg": "d8c0",
	"./i6.svg": "84b9",
	"./i7.svg": "d908",
	"./i8.svg": "8831",
	"./rec.svg": "9258"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3ba9";